module.exports = __webpack_public_path__ + "assets/img/station17.d2c2807c.png";